module.exports = __webpack_public_path__ + "static/media/500000.66ce53cf.png";